import ProjectSelect from './project-select.vue'
ProjectSelect.install = function (Vue) {
  Vue.component(ProjectSelect.name, ProjectSelect);
};
export default ProjectSelect



// WEBPACK FOOTER //
// ./src/omnis-business/project-select/index.js